import { render, staticRenderFns } from "./SettingBox.vue?vue&type=template&id=6f91066a&scoped=true&"
import script from "./SettingBox.vue?vue&type=script&lang=js&"
export * from "./SettingBox.vue?vue&type=script&lang=js&"
import style0 from "./SettingBox.vue?vue&type=style&index=0&id=6f91066a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f91066a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
